import { QueryKey, useQuery, UseQueryOptions } from 'react-query';
import { getSkillDrawerData } from 'services/app';

export default function useSkillDrawerData(
  skillSlug: string,
  options?: Omit<UseQueryOptions<any, Error, any, QueryKey>, 'queryKey'>
) {
  return useQuery<any, Error>(
    `skill-${skillSlug}-drawer-data`,
    () =>
      getSkillDrawerData(skillSlug).then((response) => {
        if (!response.ok) {
          throw new Error(response.originalError?.message);
        }
        return response.data;
      }),
    {
      ...options,
      cacheTime: 600000,
      retry: false,
    }
  );
}
